export default "__VITE_PUBLIC_ASSET__51be9fd5__"